interface MoneyInputProps {
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  placeholder?: string;
  required?: boolean;
}

/** Bare numeric input bound to `number | null` (empty string <-> null). */
export function MoneyInput({ value, onChange, placeholder, required }: MoneyInputProps) {
  return (
    <input
      type="number"
      step="0.01"
      inputMode="decimal"
      required={required}
      value={value ?? ""}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}
    />
  );
}
